import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ertigaonrentinmumbai() {



    const cardData = {

keyword: "Ertiga On Rent in Mumbai",

headingDescription:
    "Mumbai Airport Cab offers affordable and comfortable Ertiga On Rent in Mumbai for airport transfers, local travel, corporate commuting, family vacations, wedding transportation, sightseeing tours, and outstation journeys. The Maruti Suzuki Ertiga is one of the most preferred 6 and 7-seater MPVs, known for its spacious interiors, comfortable seating, fuel efficiency, and smooth ride quality. We provide well-maintained Ertiga vehicles with professional chauffeurs, 24x7 availability, transparent pricing, doorstep pickup and drop, and flexible rental packages to ensure a safe, convenient, and hassle-free travel experience across Mumbai and nearby destinations.",

topPlaces: [
    {
        title: "Kaas Plateau",
        description:
            "Kaas Plateau, often called the Valley of Flowers of Maharashtra, is a UNESCO World Natural Heritage Site famous for its seasonal wildflower bloom and breathtaking natural beauty. Families and nature lovers frequently book Ertiga rentals for a comfortable road trip to this unique destination."
    },
    {
        title: "Diveagar",
        description:
            "Diveagar is a beautiful Konkan beach destination known for its clean shoreline, peaceful atmosphere, and relaxing coastal environment. The Ertiga is an ideal vehicle for families traveling together and enjoying a comfortable beach vacation from Mumbai."
    },
    {
        title: "Malshej Ghat",
        description:
            "Malshej Ghat is one of Maharashtra’s most scenic mountain passes, featuring waterfalls, mist-covered valleys, and lush greenery during the monsoon season. An Ertiga rental provides a smooth and enjoyable journey for groups exploring this natural wonder."
    },
    {
        title: "Chikhaldara",
        description:
            "Chikhaldara is Maharashtra’s only coffee-growing hill station, known for its wildlife, viewpoints, and cool climate. Travelers prefer Ertiga rentals for the spacious seating and comfort required for long-distance family trips."
    },
    {
        title: "Murud-Janjira",
        description:
            "Murud-Janjira is famous for its historic sea fort and pristine beaches along the Konkan coast. The destination is ideal for family outings, and an Ertiga offers ample space for passengers and luggage."
    },
    {
        title: "Akkalkot",
        description:
            "Akkalkot is a renowned pilgrimage destination associated with Shri Swami Samarth Maharaj. Devotees traveling in groups often choose Ertiga rentals for a comfortable and economical spiritual journey."
    },
    {
        title: "Velas",
        description:
            "Velas is known for its turtle conservation festival and untouched coastal beauty. It is a peaceful getaway destination where families can enjoy nature while traveling comfortably in an Ertiga."
    },
    {
        title: "Ganagapur",
        description:
            "Ganagapur is an important pilgrimage center dedicated to Shri Dattatreya and attracts devotees from across India. Ertiga rentals are popular for group temple visits and long-distance spiritual travel."
    },
    {
        title: "Tadoba National Park",
        description:
            "Tadoba National Park is one of Maharashtra’s premier wildlife destinations, famous for tiger sightings and jungle safaris. Families and nature enthusiasts often book Ertiga rentals for comfortable travel to this adventure-filled destination."
    },
    {
        title: "Mandu",
        description:
            "Mandu is a historic town in Madhya Pradesh known for magnificent forts, palaces, and architectural heritage. An Ertiga rental is a practical and comfortable choice for families exploring this culturally rich destination."
    }
],



services: [
{
name: "Ertiga On Rent in Mumbai",
description: "Mumbai Airport Cab offers Ertiga On Rent in Mumbai service for customers looking for spacious, comfortable, and budget-friendly transportation for family trips, airport transfers, corporate travel, sightseeing tours, wedding events, and outstation journeys. Our well-maintained Maruti Ertiga vehicles provide comfortable seating, ample luggage space, air-conditioned interiors, and smooth ride quality for both city and highway travel. With professional chauffeurs, transparent pricing, doorstep pickup and drop service, flexible booking options, and 24x7 customer support, we ensure every journey is safe, convenient, and enjoyable. Whether you need transportation for a few hours, a full day, or a multi-day tour, our Ertiga rental service delivers reliable and comfortable travel solutions across Mumbai and surrounding destinations."
},
{
name: "Mumbai Ertiga Rental",
description: "Mumbai Airport Cab provides Mumbai Ertiga Rental service with chauffeur-driven vehicles designed for comfortable family travel, airport transportation, business trips, holiday tours, weekend getaways, and long-distance journeys. Our Ertiga fleet is regularly maintained to ensure cleanliness, safety, and excellent performance while offering spacious seating and luggage capacity. We provide experienced drivers, transparent rates, flexible schedules, instant booking confirmation, and dedicated customer assistance to make every journey smooth, reliable, and stress-free for travellers across Mumbai and major destinations throughout India."
},
{
name: "Ertiga Cab Mumbai",
description: "Book Ertiga Cab Mumbai with Mumbai Airport Cab and enjoy reliable transportation for local travel, airport pickups, family functions, corporate meetings, sightseeing tours, and outstation trips. Our spacious Ertiga vehicles offer comfortable seating, air-conditioned comfort, professional chauffeur service, and sufficient luggage space for a pleasant travel experience. We focus on punctuality, safety, vehicle cleanliness, and customer satisfaction while delivering affordable and dependable transportation solutions for individuals, families, and groups throughout Mumbai and beyond."
},
{
name: "Rent Ertiga Mumbai",
description: "Rent Ertiga Mumbai through Mumbai Airport Cab for affordable and comfortable travel suitable for family vacations, business transportation, airport transfers, weddings, weekend trips, and intercity journeys. Our professionally maintained vehicles provide excellent comfort and convenience while experienced chauffeurs ensure safe and timely travel. With flexible rental packages, transparent pricing, customized travel plans, and 24x7 booking support, we deliver reliable transportation solutions designed to meet diverse travel requirements."
},
{
name: "Mumbai Ertiga Car Hire",
description: "Mumbai Airport Cab offers Mumbai Ertiga Car Hire service for customers seeking practical and comfortable transportation for city travel, airport transfers, holiday tours, family outings, and long-distance journeys. Our spacious vehicles are ideal for small groups and families, offering comfortable seating, ample luggage space, and smooth ride quality. Supported by professional chauffeurs, convenient booking options, and dependable customer service, we ensure a comfortable and hassle-free travel experience every time."
},
{
name: "Ertiga Outstation Cab Mumbai",
description: "Book Ertiga Outstation Cab Mumbai with Mumbai Airport Cab for convenient travel to destinations such as Pune, Nashik, Shirdi, Goa, Mahabaleshwar, Lonavala, Aurangabad, and many more. Our comfortable Ertiga vehicles are perfect for long-distance journeys, offering spacious seating, luggage capacity, air-conditioned comfort, and professional chauffeur service. We provide transparent pricing, flexible itineraries, safe driving practices, and reliable customer support to ensure enjoyable and stress-free outstation travel."
},
{
name: "Mumbai Ertiga Taxi Service",
description: "Mumbai Ertiga Taxi Service by Mumbai Airport Cab provides dependable transportation for airport transfers, local city rides, business travel, family functions, sightseeing tours, and outstation trips. Our Ertiga vehicles combine affordability with comfort, offering spacious interiors, clean cabins, and professional driver assistance. We are committed to delivering punctual service, safe travel, transparent pricing, and excellent customer satisfaction for every passenger and every journey."
},
{
name: "Ertiga Booking Mumbai",
description: "Mumbai Airport Cab provides Ertiga Booking Mumbai service with easy reservation procedures, instant booking confirmation, flexible travel schedules, and dedicated customer support. Whether you need a vehicle for airport transportation, city travel, family events, holiday tours, or corporate journeys, our well-maintained Ertiga fleet and experienced chauffeurs ensure safe, comfortable, and reliable transportation. We strive to make every booking process simple, convenient, and completely hassle-free."
},
{
name: "Ertiga Family Cab Mumbai",
description: "Ertiga Family Cab Mumbai service is designed specifically for families seeking spacious, comfortable, and affordable transportation for vacations, airport transfers, sightseeing trips, weddings, and weekend outings. Mumbai Airport Cab offers clean and well-maintained Ertiga vehicles with generous seating capacity, luggage space, professional chauffeurs, and flexible travel plans. Our focus on safety, comfort, and customer convenience ensures enjoyable family journeys from start to finish."
},
{
name: "Mumbai Ertiga Airport Cab",
description: "Mumbai Airport Cab offers Mumbai Ertiga Airport Cab service with reliable pickup and drop facilities for domestic and international airport terminals. Our chauffeurs monitor flight schedules, assist with luggage, and ensure timely transportation using comfortable and spacious Ertiga vehicles. Whether travelling alone, with family, or in a group, passengers enjoy convenient airport transfers, professional service, and a stress-free travel experience."
},
{
name: "Ertiga Chauffeur Service Mumbai",
description: "Ertiga Chauffeur Service Mumbai combines comfortable vehicle travel with experienced professional drivers trained in customer service, safe driving, and route management. Mumbai Airport Cab provides chauffeur-driven Ertiga vehicles for business travel, airport transfers, sightseeing tours, family functions, and outstation journeys. Our commitment to punctuality, professionalism, and passenger comfort ensures a premium travel experience at affordable rates."
},
{
name: "Ertiga One Way Cab Mumbai",
description: "Mumbai Airport Cab provides Ertiga One Way Cab Mumbai service for customers seeking economical and convenient transportation without the need for return travel charges. Our one-way cab service is ideal for airport transfers, intercity travel, business trips, family visits, and holiday journeys. With comfortable vehicles, professional chauffeurs, transparent pricing, and flexible pickup locations, we ensure smooth and cost-effective travel for every passenger."
},
{
name: "Ertiga Round Trip Mumbai",
description: "Ertiga Round Trip Mumbai service offers reliable transportation solutions for return journeys including family vacations, business visits, pilgrimage tours, sightseeing trips, and weekend getaways. Mumbai Airport Cab provides comfortable Ertiga vehicles, experienced drivers, flexible schedules, and transparent rates to ensure a convenient and enjoyable round-trip travel experience. We focus on safety, punctuality, and customer satisfaction throughout the entire journey."
},
{
name: "Ertiga Travel Cab Mumbai",
description: "Book Ertiga Travel Cab Mumbai with Mumbai Airport Cab for local sightseeing, holiday tours, corporate travel, airport transportation, family outings, and outstation journeys. Our spacious Ertiga vehicles are designed to provide comfort, convenience, and affordability while our professional chauffeurs ensure safe and reliable travel. We offer customized travel solutions, flexible itineraries, and dedicated customer support for every travel requirement."
},
{
name: "Ertiga Long Distance Cab",
description: "Ertiga Long Distance Cab service is ideal for extended road trips, intercity travel, pilgrimage tours, business journeys, and family vacations. Mumbai Airport Cab provides comfortable and fuel-efficient Ertiga vehicles with experienced chauffeurs, spacious interiors, ample luggage capacity, and flexible travel plans. We ensure passengers enjoy a safe, smooth, and relaxing journey regardless of the distance travelled."
},
{
name: "Ertiga Weekend Rental Mumbai",
description: "Mumbai Airport Cab offers Ertiga Weekend Rental Mumbai service for travellers planning short vacations, family outings, beach trips, hill station tours, and leisure travel. Our comfortable Ertiga vehicles provide spacious seating, air-conditioned comfort, professional driver service, and convenient booking options. We help customers enjoy memorable weekend getaways with reliable transportation and personalized travel support."
},
{
name: "Ertiga Group Travel Mumbai",
description: "Ertiga Group Travel Mumbai service is perfect for families, friends, corporate teams, and small groups requiring comfortable transportation for events, tours, airport transfers, and outstation journeys. Mumbai Airport Cab provides spacious Ertiga vehicles, experienced chauffeurs, flexible travel schedules, and affordable pricing. We focus on delivering safe, convenient, and enjoyable travel experiences for groups of all sizes."
},
{
name: "Ertiga Affordable Cab Mumbai",
description: "Mumbai Airport Cab provides Ertiga Affordable Cab Mumbai service for customers seeking cost-effective transportation without compromising comfort, safety, or service quality. Our well-maintained Ertiga vehicles are suitable for airport transfers, family travel, business trips, sightseeing tours, and long-distance journeys. With competitive pricing, professional chauffeurs, and dependable service, we offer excellent value for every travel requirement."
},
{
name: "Ertiga Mumbai Tour Cab",
description: "Book Ertiga Mumbai Tour Cab with Mumbai Airport Cab for customized sightseeing tours, holiday packages, religious trips, weekend excursions, and family vacations. Our comfortable Ertiga vehicles, professional chauffeurs, flexible itineraries, and customer-focused service ensure memorable and enjoyable travel experiences. We provide reliable transportation to popular tourist destinations while maintaining high standards of comfort, safety, and convenience throughout the journey."
}
],

tableData: [
["Ertiga On Rent in Mumbai","Mumbai Ertiga Rental"],
["Ertiga Cab Mumbai","Rent Ertiga Mumbai"],
["Mumbai Ertiga Car Hire","Ertiga Outstation Cab Mumbai"],
["Mumbai Ertiga Taxi Service","Ertiga Booking Mumbai"],
["Ertiga Family Cab Mumbai","Mumbai Ertiga Airport Cab"],
["Ertiga Chauffeur Service Mumbai","Ertiga One Way Cab Mumbai"],
["Ertiga Round Trip Mumbai","Ertiga Travel Cab Mumbai"],
["Ertiga Long Distance Cab","Ertiga Weekend Rental Mumbai"],
["Ertiga Group Travel Mumbai","Ertiga Affordable Cab Mumbai"],
["Ertiga Mumbai Tour Cab","Mumbai Ertiga Travel Service"]
],


whychoose: [
    {
        WhyChooseheading: "Premium Innova Crysta on Rent in Mumbai",
        WhyChoosedescription: "Mumbai Airport Cabs provides reliable Innova Crysta Rental Services in Mumbai for airport transfers, corporate travel, family vacations, weddings, sightseeing tours, and outstation journeys."
    },
    {
        WhyChooseheading: "Luxury and Comfort for Every Journey",
        WhyChoosedescription: "Toyota Innova Crysta is known for its premium interiors, spacious seating, superior comfort, and smooth ride quality, making it ideal for long-distance and executive travel."
    },
    {
        WhyChooseheading: "Perfect for Family and Corporate Travel",
        WhyChoosedescription: "Whether you are planning a family trip, business meeting, airport transfer, or group tour, Innova Crysta offers a comfortable and premium travel experience."
    },
    {
        WhyChooseheading: "Available for Local and Outstation Trips",
        WhyChoosedescription: "Customers can hire Innova Crysta for Mumbai city travel as well as destinations like Pune, Nashik, Shirdi, Mahabaleshwar, Goa, Ahmedabad, Jaipur, and many other locations."
    },
    {
        WhyChooseheading: "Airport Pickup and Drop Specialists",
        WhyChoosedescription: "We provide seamless airport transfers with Innova Crysta vehicles for domestic and international travelers arriving at or departing from Mumbai Airport."
    },
    {
        WhyChooseheading: "Professional Chauffeur-Driven Service",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, punctual service, route expertise, and a stress-free travel experience throughout the journey."
    },
    {
        WhyChooseheading: "Ideal for VIP and Executive Transportation",
        WhyChoosedescription: "Many business executives, corporate clients, and premium travelers prefer Innova Crysta for meetings, conferences, airport transfers, and official travel."
    },
    {
        WhyChooseheading: "Flexible One-Way and Round Trip Options",
        WhyChoosedescription: "Customers can choose one-way transfers, round trips, multi-day tours, and customized travel packages according to their travel requirements."
    }
]
};

const faqData = [
    {
        question: "Why choose Innova Crysta on Rent in Mumbai?",
        answer: "Innova Crysta offers premium comfort, spacious seating, luxury interiors, excellent ride quality, and ample luggage space for all types of travel."
    },
    {
        question: "Can I book an Innova Crysta for Mumbai Airport transfers?",
        answer: "Yes, Innova Crysta vehicles are available for airport pickup and drop services from Mumbai Airport."
    },
    {
        question: "Is Innova Crysta available for outstation travel?",
        answer: "Yes, customers can hire Innova Crysta for Pune, Nashik, Shirdi, Goa, Mahabaleshwar, Ahmedabad, Indore, Bangalore, and many other destinations."
    },
    {
        question: "How many passengers can travel in an Innova Crysta?",
        answer: "Innova Crysta comfortably accommodates up to 6 to 7 passengers along with luggage depending on the seating arrangement."
    },
    {
        question: "Can corporate clients book Innova Crysta rentals?",
        answer: "Yes, many executives, corporate organizations, and business travelers prefer Innova Crysta for premium transportation."
    },
    {
        question: "Do you provide chauffeur-driven Innova Crysta rentals?",
        answer: "Yes, all Innova Crysta rentals from Mumbai Airport Cabs include professional and experienced chauffeurs."
    },
    {
        question: "Can I book an Innova Crysta for weddings and events?",
        answer: "Yes, Innova Crysta is frequently booked for weddings, VIP guest transportation, family functions, and corporate events."
    },
    {
        question: "Are one-way and round-trip bookings available?",
        answer: "Yes, customers can choose one-way transfers, round trips, airport transfers, and customized travel packages."
    },
    {
        question: "Can I schedule an Innova Crysta rental in advance?",
        answer: "Yes, advance booking is recommended to ensure vehicle availability during weekends, holidays, and peak travel seasons."
    },
    {
        question: "How can I book an Innova Crysta on Rent in Mumbai?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rahul Merchant",
        feedback:
            "For our corporate airport transfer, the Innova Crysta provided exceptional comfort and professionalism. The vehicle was immaculate and the chauffeur was highly courteous.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Snehal Patwardhan",
        feedback:
            "We hired an Innova Crysta for our family vacation and were extremely impressed. The spacious seating, smooth journey, and excellent service made the trip memorable.",
        rating: 5
    }
];









































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Ertiga on Rent in Mumbai",
"image": "https://www.mumbaiairportcabs.com/assets/images/ertiga-on-rent-mumbai.jpg",
"description": "Book Ertiga on rent in Mumbai for comfortable family travel, airport transfers, weddings, and outstation trips. Mumbai Airport Cabs offers well-maintained Ertiga vehicles with professional drivers, spacious seating, and reliable 24x7 service across Mumbai.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/ertiga-on-rent-in-mumbai"
}
};







    return (
        <div>



<Helmet>
  <title>Ertiga on Rent in Mumbai | Ertiga Cab Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Ertiga on rent in Mumbai for family trips, airport transfers, weddings, and outstation travel. Comfortable 6-7 seater Ertiga cab service with professional drivers and 24x7 availability."
/>

<meta
 name="keywords"
 content="ertiga on rent in mumbai, mumbai ertiga rental, ertiga cab mumbai, rent ertiga mumbai, mumbai ertiga car hire, ertiga outstation cab mumbai, mumbai ertiga taxi service, ertiga booking mumbai, ertiga family cab mumbai, mumbai ertiga airport cab, ertiga chauffeur service mumbai, ertiga one way cab mumbai, ertiga round trip mumbai, ertiga travel cab mumbai"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/67.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Ertigaonrentinmumbai;